export function getUnleashFeatureWithPodletPrefix(nameId: string): string {
    return 'displayads-podlet-horseshoe.' + nameId;
}

export const UNLEASH_FEATURE_NAMES = {
    appNexus9826: 'appNexus9826',
    astFallback: 'ast.fallback',
    enableTransparencyCogwheel: 'enableTransparencyCogwheel',
    safeFrame: 'safeFrame',
    enableNRM: 'enableNRM',
    enableAdIntervalVariant: 'enableAdIntervalVariant',
    enableUpdatedExternalIdKeyword: 'enableUpdatedExternalIdKeyword',
    enableGlimr: 'enableGlimr',
    enableMarketContentSplitView: 'enableMarketContentSplitView',
    enableMarketContentDesignExperiment:
        'enableMarketContentDesignExperimentV12',
    stickTitleBold: 'stickTitleBold',
};
